import React from 'react';
import { useParams } from 'react-router';

// import styled from '@emotion/styled';
import Stars from '../../../components/Badge/Stars';
import StatusCell from '../../../components/Badge/StatusCell';
import Table from '../../../components/Table/Table';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';

// import Tooltip from '../../../components/Tooltip/Tooltip';

const DriverPerformanceData = () => {
  const { driverId } = useParams();

  return (
    // <Container>
    //   <HeaderArea>
    //     <Header>
    //       Incident Report
    //       <Tooltip content='Real-time incident analytics and insights' />
    //     </Header>
    //   </HeaderArea>

    <Table
      // border
      // tableTitle='Incident Reports'
      tableHeader={{
        'Date logged': 'createdAt',
        'Report type': 'reportType',
        'Severity rating': 'severityRating',
      }}
      tableDataSourceUrl={`api/v1/dispatchers/${driverId}/history`}
      cellsCustomComp={{
        createdAt: <TableDateTimeFormatter dataKey='createdAt' />,
        reportType: <StatusCell statusKey='reportType' />,
        severityRating: <Stars dataKey='severityRating' />,
      }}
    />
    // </Container>
  );
};

export default DriverPerformanceData;

// const Container = styled.div`
//   border: 1px solid ${({ theme }) => theme.palette.borderColor};
//   padding: 24px;
//   border-radius: 8px;
//   display: flex;
//   flex-direction: column;
//   gap: 18px;
// `;

// const HeaderArea = styled.div`
//   font-weight: 600;
//   font-size: 18px;
//   display: flex;
//   align-items: center;

//   margin-bottom: 18px;
// `;

// const Header = styled.div`
//   font-weight: 600;
//   font-size: 18px;
// `;
